import {
  notificationPreferencesSchema,
  notificationSchema,
  unreadCountSchema,
  type Notification,
  type NotificationListQuery,
  type NotificationPreferences,
  type Page,
  type UnreadCount,
  type UpdateNotificationPreferencesInput,
} from '@teentack/shared';
import { apiFetch, post } from '@/lib/api-client';
import { fetchPage } from '@/lib/api-page';

/** The inbox, newest first. Scoped server-side to the signed-in account. */
export function fetchNotifications(
  query: Partial<NotificationListQuery> = {},
): Promise<Page<Notification>> {
  return fetchPage('/notifications', notificationSchema, {
    ...query,
    // URLSearchParams would turn `false` into the string "false", which the
    // server would coerce back to true. Only send the flag when it is on.
    unreadOnly: query.unreadOnly ? 'true' : undefined,
  });
}

export async function fetchUnreadCount(): Promise<UnreadCount> {
  return unreadCountSchema.parse(await apiFetch<unknown>('/notifications/unread-count'));
}

/** Omit the ids to mark the whole inbox read. */
export async function markNotificationsRead(
  notificationIds?: string[],
): Promise<{ updated: number }> {
  return post<{ updated: number }>(
    '/notifications/read',
    notificationIds ? { notificationIds } : {},
  );
}

export async function fetchNotificationPreferences(): Promise<NotificationPreferences> {
  return notificationPreferencesSchema.parse(await apiFetch<unknown>('/notifications/preferences'));
}

export async function saveNotificationPreferences(
  input: UpdateNotificationPreferencesInput,
): Promise<NotificationPreferences> {
  const result = await apiFetch<unknown>('/notifications/preferences', {
    method: 'PATCH',
    body: JSON.stringify(input),
  });
  return notificationPreferencesSchema.parse(result);
}
